// @flow
import Color from 'color';

export function getContrastColor(blackColorStr: string, whiteColorStr: string) {
  return (bgColorStr: string): string => {
    const blackColor = Color(blackColorStr);
    const whiteColor = Color(whiteColorStr);
    const bgColor = Color(bgColorStr);

    return bgColor.contrast(blackColor) > bgColor.contrast(whiteColor) + 3
      ? blackColorStr
      : whiteColorStr;
  };
}

export default getContrastColor;



// WEBPACK FOOTER //
// ./src/themes/mixins/getContrastColor.js